import React, { useState } from 'react';
import '../CSS/CafeAi.css';

const CafeAI = () => {
  const [messages, setMessages] = useState([]);
  const [order, setOrder] = useState([]);
  const [isListening, setIsListening] = useState(false);

  // Complete menu data structure
  const menu = {
    // Café
    'Espresso': { prices: { chico: 2400 } },
    'Espresso Double Shot': { prices: { chico: 3240 } },
    'Latte w/ Whole Milk': { prices: { chico: 5400, mediano: 6000, grande: 6600 } },
    'Flat White w/ Whole Milk': { prices: { chico: 6240, mediano: 6840, grande: 7440 } },
    'Cappuccino w/ Whole Milk': { prices: { chico: 5500, mediano: 6100, grande: 6700 } },
    'Americano': { prices: { chico: 5100, mediano: 5700, grande: 6300 } },
    // Add all other items following the same pattern...
    
    // Comida Dulce
    'Crossiant con Chocolate y Banana': { prices: { standard: 4740 } },
    'Alfajor de Chocolate': { prices: { standard: 3750 } },
    // ... continue with all other items
  };

  const findItemPrice = (itemName, size = 'standard') => {
    const item = menu[itemName];
    if (!item) return null;
    
    const price = item.prices[size.toLowerCase()] || Object.values(item.prices)[0];
    return price || null;
  };

  const processOrder = async (transcript) => {
    try {
      const API_KEY = 'sk-9cfa0cc5b47c4de89809d472f104828a'; // ⚠️ INSECURE - for testing only
      
      const response = await fetch('https://api.deepseek.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`,
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
          model: "deepseek-chat",
          messages: [{
            role: "system",
            content: `Analiza pedidos en español usando este menú: ${JSON.stringify(menu)}. Responde EXCLUSIVAMENTE con JSON válido: {
              "items": [{
                "name": "Nombre exacto del ítem",
                "quantity": número,
                "size": "chico/mediano/grande/standard"
              }],
              "response": "Confirmación en español incluyendo total en pesos"
            }`
          }, {
            role: "user",
            content: transcript
          }]
        })
      });

      if (!response.ok) throw new Error('Error en la API');
      
      const data = await response.json();
      const content = JSON.parse(data.choices[0].message.content);
      
      // Validate and calculate prices
      const validatedItems = content.items.map(item => {
        const price = findItemPrice(item.name, item.size);
        if (!price) throw new Error(`Ítem no válido: ${item.name}`);
        
        return {
          ...item,
          price,
          total: price * item.quantity
        };
      });

      const orderTotal = validatedItems.reduce((sum, item) => sum + item.total, 0);
      
      // Update state
      setOrder(prev => [...prev, ...validatedItems]);
      setMessages(prev => [
        ...prev,
        { text: transcript, user: true },
        { text: content.response, user: false },
        { text: `Total del pedido: $${orderTotal.toLocaleString('es-AR')}`, user: false }
      ]);

    } catch (error) {
      setMessages(prev => [
        ...prev,
        { text: `Error: ${error.message}`, user: false }
      ]);
      console.error('Order Error:', error);
    }
  };

  const startListening = () => {
    const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
    recognition.lang = 'es-ES';
    
    recognition.onresult = (e) => {
      const transcript = e.results[0][0].transcript;
      processOrder(transcript);
    };
    
    recognition.start();
    setIsListening(true);
    recognition.onend = () => setIsListening(false);
  };

  return (
    <div className="cafe-container">
      <div className="chat-window">
        {messages.map((msg, i) => (
          <div key={i} className={`message ${msg.user ? 'user' : 'ai'}`}>
            {msg.text}
          </div>
        ))}
      </div>

      <div className="order-summary">
        <h3>Detalle del Pedido:</h3>
        {order.map((item, i) => (
          <div key={i} className="order-item">
            <span>{item.quantity}x {item.name} ({item.size})</span>
            <span>${item.total.toLocaleString('es-AR')}</span>
          </div>
        ))}
      </div>

      <button 
        className={`mic-button ${isListening ? 'active' : ''}`} 
        onClick={startListening}
      >
        {isListening ? 'Escuchando... 🎤' : 'Ordenar por Voz 🎤'}
      </button>
    </div>
  );
};

export default CafeAI;